import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import { motion } from 'framer-motion';

const policyVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export const PrivacyPolicy = () => {
  return (
    <Box sx={{ py: 5, px: { xs: 2, md: 6 },  minHeight: '100vh' }}>
      <motion.div initial="hidden" animate="visible" variants={policyVariants}>
        <Paper elevation={4} sx={{ p: { xs: 3, md: 5 }, borderRadius: 1, backgroundColor: 'rgb(259,259,259,0.8)' }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom fontFamily="Playfair Display" color="success.main">
             Privacy Policy – MazGuard
          </Typography>
          <Typography variant="subtitle2" gutterBottom color="text.secondary">
            Effective Date: 7/7/2025
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body1" gutterBottom>
            At <strong>MazGuard</strong>, we are committed to protecting your privacy while enabling a safe, transparent,
            and effective platform for environmental incident reporting. This Privacy Policy outlines the information we
            collect, how we use it, and your rights.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight="bold">1. What We Collect</Typography>
          <Typography variant="body2" gutterBottom>
            We collect the minimum data necessary to process environmental reports:
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>a. Personal Information</strong><br />
            - Name (optional)<br />
            - Email address and/or phone number (optional, for follow-up or verification)
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>b. Environmental Report Data</strong><br />
            - Report category (e.g., illegal dumping, deforestation, pollution)<br />
            - Description and location of incident<br />
            - Media uploads (images/videos)<br />
            - Timestamp of the report
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>c. Technical Information</strong><br />
            - Geolocation (coordinates on submission only)
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight="bold">2. How We Use Your Information</Typography>
          <Typography variant="body2" gutterBottom>
            We use your information only to:
            <ul>
              <li>Log and categorize environmental reports</li>
              <li>Notify or share reports with environmental agencies or authorities</li>
              <li>Provide status updates (if contact details are provided)</li>
              <li>Improve the quality and reliability of the platform</li>
            </ul>
            We do not use your information for advertising or commercial profiling.
          </Typography>

          <Typography variant="h6" fontWeight="bold">3. Sharing of Data</Typography>
          <Typography variant="body2" gutterBottom>
            We only share data with:
            <ul>
              <li>Verified government or environmental protection authorities</li>
              <li>Environmental NGOs or specialists involved in field response</li>
            </ul>
            We do not sell, trade, or disclose your information to advertisers or unrelated third parties.
          </Typography>

          <Typography variant="h6" fontWeight="bold">4. Data Retention</Typography>
          <Typography variant="body2" gutterBottom>
            - Report data is retained for public and agency reference<br />
            - Personal data (if provided) is stored securely and only for follow-up
          </Typography>

          <Typography variant="h6" fontWeight="bold">5. Data Security</Typography>
          <Typography variant="body2" gutterBottom>
            MazGuard uses:
            <ul>
              <li>End-to-end encryption (HTTPS)</li>
              <li>Secure servers and authentication</li>
              <li>Role-based data access</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">6. Your Rights</Typography>
          <Typography variant="body2" gutterBottom>
            You have the right to:
            <ul>
              <li>Access, correct, or delete your personal data</li>
              <li>Report misuse of your data</li>
              <li>Submit anonymous reports (when permitted)</li>
            </ul>
          </Typography>

          <Typography variant="h6" fontWeight="bold">7. Children's Privacy</Typography>
          <Typography variant="body2" gutterBottom>
            MazGuard is not intended for children under 13 without parental guidance.
          </Typography>

          <Typography variant="h6" fontWeight="bold">8. Updates to This Policy</Typography>
          <Typography variant="body2" gutterBottom>
            We may update this policy for legal or platform-related changes. Updated terms will be posted here.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" fontWeight="bold"> Contact Us</Typography>
          <Typography variant="body2">
            Email: korirbyron1@gmail.com<br />
            Phone: 0725499649
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

